import Logo from "./Logo";
import { scrollToId } from "@/lib/api";

export default function Footer() {
  return (
    <footer className="border-t border-gold/20 bg-navy-surface/60" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-3 gap-10 items-start">
          <div>
            <Logo />
            <p className="mt-6 text-xs tracking-[0.25em] uppercase text-gold font-faith">
              Digital Ministry · Kingdom Visibility · Community Impact
            </p>
          </div>
          <div className="text-sm text-slate-300 space-y-2">
            <p className="text-[10px] tracking-[0.3em] uppercase text-slate-500 mb-4">Contact</p>
            <p>Dr. Willie E. Rogers — Founder</p>
            <a data-testid="footer-email-link" href="mailto:masterteacher33.com@gmail.com"
              className="block text-gold hover:text-gold-hover transition-colors">
              masterteacher33.com@gmail.com
            </a>
            <button data-testid="footer-book-audit-button" onClick={() => scrollToId("audit")}
              className="mt-4 rounded-full border border-gold/50 px-6 py-3 text-[10px] font-bold tracking-[0.2em] uppercase text-gold transition-all hover:bg-gold hover:text-navy">
              Book Your Digital Ministry Audit
            </button>
          </div>
          <blockquote className="font-cormorant italic text-lg text-amber-100/80 leading-relaxed border-l-2 border-gold pl-5">
            “The Church does not need to become more like the world to reach the world. It needs to become more
            visible in the world.”
          </blockquote>
        </div>
        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3 text-[11px] text-slate-500">
          <p>© 2026 Minister of Social Media™ · A Kingdom Reach Media Company</p>
          <p data-testid="footer-proof-note">Proof of concept: Fountain of Living Water Apostolic Church (F.O.L.W.A.C.)</p>
        </div>
      </div>
    </footer>
  );
}
